import React, { useEffect, useState } from 'react'
import { withRouter, useHistory } from 'react-router-dom'
import { VALUES } from 'utils/constants'
import SecondaryMenu from './SecondaryMenu'
import MenuItemWithLink from './MenuItemWithLink'
import SecondaryMenuItem from './SecondaryMenuItem'
import MainMenuItems from './MainMenuItems'
import { useStateValue } from 'context/store'
import Utils from 'utils/utils'
import clsx from 'clsx'
import { makeStyles, List, Drawer, Collapse, IconButton } from '@material-ui/core'
import { Menu, MenuOpen } from '@material-ui/icons'
import '../../../assets/styles/scroll-menu-styles.css'
import logoZonaSer from 'images/zona ser.png'

// buscador
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import MaterialIcon from '../../materialIcon/materialIcon'
import CloseIcon from '@material-ui/icons/Close'

/** Breadcrumb Name Map import */
import { breadcrumbNameMap } from '../Breadcrumbs/breadcrumbNameMap'

const useStyles = makeStyles(theme => ({
   drawer: {
      width: VALUES.MENU.OPEN_MAIN_DRAWER_WIDTH,
      flexShrink: 0,
      whiteSpace: 'nowrap'
   },
   drawerOpen: {
      width: VALUES.MENU.OPEN_MAIN_DRAWER_WIDTH,
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.enteringScreen
      })
   },
   drawerClose: {
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: VALUES.MENU.CLOSED_MAIN_DRAWER_WIDTH
   },
   secondaryDrawer: {
      top: '48px',
      left: '55px',
      height: 'inherit',
      position: 'fixed',
      zIndex: 15
   },
   secondaryDrawerPaperAnchorLeft: {
      position: 'relative'
   },
   secondaryDrawerOpen: {
      width: '320px',
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.enteringScreen
      })
   },
   secondaryDrawerClosed: {
      width: '0',
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen
      })
   },
   toolbar: {
      height: '47px',
      paddingLeft: theme.spacing(0.5),
      display: 'flex',
      justifyContent: 'flex-start'
   },
   toolbarLogoContainer: {
      display: 'flex',
      alignItems: 'center'
   },
   toolbarLogo: {
      height: '30px'
   },
   toolbarMenuIcon: {
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
   },
   nestedItem: {
      paddingLeft: theme.spacing(4)
   },

   // buscador
   containerSearchMain: {
      position: 'relative'
   },

   containerSearch: {
      width: '350px',
      marginLeft: '5px'
   },

   containerSearchIcon: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
   },

   inputSearch: {
      boxShadow: '0 3px 4px -1px #d1d5db',
      color: '#000',
      marginTop: '16px',
      marginBottom: '16px',
      padding: '8px 10px 8px 40px',
      width: '350px',
      borderRadius: '0.275rem',
      border: 'none',
      fontSize: '15px',
      '&:focus': {
         outline: '2px solid transparent'
      }
   },

   IconOnly: {
      marginLeft: '8px',
      cursor: 'pointer'
   },

   iconSearch: {
      marginRight: '-40px',
      marginLeft: '10px',
      zIndex: '50',
      cursor: 'pointer'
   },
   iconClosse: {
      marginLeft: '-34px',
      cursor: 'pointer',
      height: '16px'
   },

   containerList: {
      position: 'absolute',
      backgroundColor: 'white',
      zIndex: '100',
      width: '100%',
      marginBottom: '20px',
      top: 48,
      left: 2,
      borderTop: '0.2px solid #d1d5db',
      boxShadow: '0 3px 4px -1px #d1d5db'
   },
   containerListItem: {
      margin: '10px 5px',
      display: 'flex',
      justifyItems: 'center',
      fontSize: '10px'
   },
   titleSearchResults: {
      marginLeft: '5px'
   },
   subTitleApplicationSearchResults: {
      marginLeft: '10px'
   },
   subTitleSearchResults: {
      marginLeft: '15px'
   },
   containerListItemSubTitle: {
      margin: '10px 20px',
      display: 'flex',
      justifyItems: 'center',
      fontSize: '10px',
      cursor: 'pointer'
   },
   containerSearchNull: {
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingLeft: '20px'
   }
}))

// TODO: Mejorar este componente
const LeftMenu = () => {
   const history = useHistory()
   const [{ sessionUser = {}, openMenuDrawer = {} }, dispatch] = useStateValue()

   const userSettings = sessionUser?.settings || {}
   const menus = [...(userSettings?.menus || [])]
   const isOpen = openMenuDrawer?.open

   const classes = useStyles()
   const [open, setOpen] = useState({})
   const [secondaryDrawerOpen, setSecondaryDrawerOpen] = useState(false)
   const [secondarySubmenu, setSecondarySubmenu] = useState({})

   const selectableItemsWithLink = {}
   function getSelectableItemsWithLink(menusArray) {
      if (menusArray?.length) {
         menusArray?.forEach(menuItem => {
            if (menuItem.url) {
               breadcrumbNameMap[`/dashboard${menuItem.url}`] = menuItem.title
            }

            if (menuItem.menus === null) {
               const itemTitle = Utils.getNoSpaceTitle(menuItem.title)
               selectableItemsWithLink[itemTitle] = false

               if (menuItem.url && !menuItem.url.indexOf('/applications')) {
                  breadcrumbNameMap[`/dashboard${menuItem.url}`] = menuItem.breadcrumbs
               }
            } else {
               getSelectableItemsWithLink(menuItem.menus)
            }
         })
      }
   }

   const selectableSecondaryMenuItems = {}
   const selectableMainMenuItems = {}
   function getMainAndSecondarySelectableItems(menusArray) {
      menusArray?.forEach(mainMenuItem => {
         const mainItemTitle = Utils.getNoSpaceTitle(mainMenuItem.title)
         selectableMainMenuItems[mainItemTitle] = false
         mainMenuItem?.menus?.forEach(secondarySubmenuItem => {
            const secodaryItemTitle = Utils.getNoSpaceTitle(secondarySubmenuItem.title)
            selectableSecondaryMenuItems[secodaryItemTitle] = false
         })
      })
   }

   useEffect(() => {
      getMainAndSecondarySelectableItems(userSettings.menus)
      dispatch({
         type: 'SET_MAIN_MENU_ITEM_SELECTION_INITIAL_STATE',
         selectableMainMenuItems
      })
      dispatch({
         type: 'SET_SECONDARY_MENU_ITEM_SELECTION_INITIAL_STATE',
         selectableSecondaryMenuItems
      })
      getSelectableItemsWithLink(userSettings.menus)
      dispatch({
         type: 'SET_ITEM_WITH_LINK_SELECTION_INITIAL_STATE',
         selectableItemsWithLink
      })
   }, [])

   const buildCollapsableMenu = menu => {
      return menu?.menus?.map(submenu => (
         <Collapse className={classes.nestedItem} key={submenu.id} in={open[menu.id]} timeout="auto" unmountOnExit>
            {submenu?.menus?.length ? (
               <SecondaryMenuItem
                  submenu={submenu}
                  open={open}
                  setOpen={setOpen}
                  buildCollapsableMenu={buildCollapsableMenu}
               />
            ) : (
               <MenuItemWithLink
                  parentMenuItem={menu.title}
                  submenu={submenu}
                  setSecondaryDrawerOpen={setSecondaryDrawerOpen}
               />
            )}
         </Collapse>
      ))
   }

   useEffect(() => {
      if (open) {
         addStyleScroll()
      }
   }, [isOpen])

   const addStyleScroll = () => {
      const textAreaElement = document.getElementById('drawerComponent')
      const classes = textAreaElement.classList
      isOpen ? classes.add('scroll') : (textAreaElement.style.overflow = 'hidden')
      const secundElement = document.getElementsByClassName('MuiDrawer-paperAnchorDockedLeft')
      if (secundElement[0].classList) {
         secundElement[0].classList.add('scroll')
         isOpen ? (secundElement[0].style.overflow = 'scroll') : (secundElement[0].style.overflow = 'hidden')
      }
   }

   const openSecondaryMenu = submenu => {
      setSecondarySubmenu(submenu)
      dispatch({ type: 'CLOSE_MENU_DRAWER' })
      setSecondaryDrawerOpen(true)
   }

   // buscador
   const [searchMenu, setSearchMenu] = useState('')
   const [searchResults, setSearchResults] = useState([])
   const [menuRender, setMenuRender] = useState([])
   const [showSubMenu, setShowSubMenu] = useState(false)
   const [searchComplete, setSearchComplete] = useState(false)
   const [searchNull, setSearchNull] = useState(false)

   useEffect(() => {
      setMenuRender(menus)
   }, [])

   const handleChangeMenu = event => {
      setSearchMenu(event.target.value)
      setSearchComplete(false)
      setSearchNull(false)
   }

   useEffect(() => {
      const newArray = []
      const newArrayTitle = []
      let menuHeader = {}

      const menu = menus.map(menu => {
         menuHeader = {}
         menu.menus.map(subMenu => {
            subMenu.menus.map(subMenuItems => {
               subMenuItems.menus.map(subMenuSubItems => {
                  const { breadcrumbs, url, id } = subMenuSubItems
                  const titleMenuSplit = breadcrumbs.split(';')
                  if (titleMenuSplit[3].toLowerCase().includes(searchMenu.toLowerCase())) {
                     newArray.push({
                        id: breadcrumbs,
                        title: menu.breadcrumbs,
                        icon: menu.icon,
                        subTitle: titleMenuSplit[3].toUpperCase(),
                        url
                     })
                     menuHeader = {
                        id,
                        title: menu.breadcrumbs,
                        application: titleMenuSplit[1],
                        subTitle: titleMenuSplit[2],
                        menus: menu.menus
                     }
                  }
               })
            })
         })
         if (Object.keys(menuHeader)?.length) {
            newArrayTitle.push({ menu: menuHeader, subMenu: newArray })
            setSearchResults(newArrayTitle)
         }
      })

      if (searchMenu == '') {
         setShowSubMenu(false)
      } else {
         setShowSubMenu(true)
      }
   }, [searchMenu])

   const handleCloseResults = () => {
      setShowSubMenu(false)
      setSearchMenu('')
   }

   const redirectSearch = url => {
      history.push(`/dashboard${url}`)
   }

   const handleKey = e => {
      if (e.key == 'Enter') {
         const filterSearch = []

         setSearchComplete(true)
         searchResults.map(e => {
            e.subMenu.map(e => {
               filterSearch.push(e)
            })
         })

         const respuesta = filterSearch.find(e => e.subTitle == searchMenu.toUpperCase())
         if (!respuesta) {
            setSearchNull(true)
         }
      }
   }

   return (
      <>
         <Drawer
            id="drawerComponent"
            variant="permanent"
            className={clsx(classes.drawer, {
               [classes.drawerOpen]: isOpen,
               [classes.drawerClose]: !isOpen
            })}
            classes={{
               paper: clsx({
                  [classes.drawerOpen]: isOpen,
                  [classes.drawerClose]: !isOpen
               })
            }}
         >
            <div data-wt="welcometour_leftmenu">
               <div className={classes.toolbar}>
                  <IconButton
                     className={classes.toolbarMenuIcon}
                     onClick={() => {
                        if (secondaryDrawerOpen) {
                           setSecondaryDrawerOpen(false)
                        }
                        isOpen ? dispatch({ type: 'CLOSE_MENU_DRAWER' }) : dispatch({ type: 'OPEN_MENU_DRAWER' })
                     }}
                  >
                     {isOpen ? <MenuOpen /> : <Menu />}
                  </IconButton>
                  <div className={classes.toolbarLogoContainer}>
                     <img className={classes.toolbarLogo} src={logoZonaSer} alt={'Logo Zona Ser'} />
                  </div>
               </div>
               <List component="div" disablePadding>
                  <div
                     className={classes.containerSearch}
                     onClick={() => {
                        isOpen ? '' : dispatch({ type: 'OPEN_MENU_DRAWER' })
                     }}
                  >
                     {isOpen == false && (
                        <div>
                           <SearchIcon className={classes.IconOnly} />
                        </div>
                     )}
                     {isOpen == true && (
                        <div className={classes.containerSearchMain}>
                           <div className={classes.containerSearchIcon}>
                              <SearchIcon className={classes.iconSearch} />
                              <input
                                 type="text"
                                 className={classes.inputSearch}
                                 placeholder="Buscar en el menú y presionar enter"
                                 value={searchMenu}
                                 onChange={handleChangeMenu}
                                 onKeyUp={handleKey}
                              />
                              {showSubMenu && <CloseIcon onClick={handleCloseResults} className={classes.iconClosse} />}
                           </div>
                           {showSubMenu && (
                              <div className={classes.containerList}>
                                 {searchNull && (
                                    <div className={classes.containerSearchNull}>Búsqueda no encontrada</div>
                                 )}
                                 {!searchNull &&
                                    searchResults.map(menu => (
                                       <div>
                                          <div className={classes.containerListItem} key={menu.id}>
                                             <span className={classes.titleSearchResults}>{menu.menu.title}</span>
                                          </div>
                                          <div className={classes.containerListItem} key={menu.id}>
                                             <span className={classes.subTitleApplicationSearchResults}>
                                                {menu.menu.application}
                                             </span>
                                          </div>
                                          <div className={classes.containerListItem} key={menu.id}>
                                             <span className={classes.subTitleSearchResults}>{menu.menu.subTitle}</span>
                                          </div>

                                          {menu.subMenu.map(item => (
                                             <>
                                                {menu.menu.title == item.title && (
                                                   <div className={classes.containerListItemSubTitle} key={item.id}>
                                                      <MaterialIcon
                                                         fill="outlined"
                                                         name={item.icon || 'select_all'}
                                                         size="15"
                                                      />
                                                      <span
                                                         className={classes.titleSearchResults}
                                                         onClick={() => redirectSearch(item.url)}
                                                      >
                                                         {item.subTitle}
                                                      </span>
                                                   </div>
                                                )}
                                             </>
                                          ))}
                                       </div>
                                    ))}
                              </div>
                           )}
                        </div>
                     )}
                  </div>
                  {menus.map((submenu, index) => (
                     <MainMenuItems key={`menuData-${index}`} submenu={submenu} openSecondaryMenu={openSecondaryMenu} />
                  ))}
               </List>
            </div>
         </Drawer>
         <Drawer
            variant="permanent"
            className={clsx(classes.secondaryDrawer, {
               [classes.secondaryDrawerOpen]: secondaryDrawerOpen,
               [classes.secondaryDrawerClosed]: !secondaryDrawerOpen
            })}
            classes={{
               paper: clsx(classes.secondaryDrawerPaperAnchorLeft, {
                  [classes.secondaryDrawerOpen]: secondaryDrawerOpen,
                  [classes.secondaryDrawerClosed]: !secondaryDrawerOpen
               })
            }}
         >
            <SecondaryMenu
               secondarySubmenu={secondarySubmenu}
               setSecondaryDrawerOpen={setSecondaryDrawerOpen}
               buildCollapsableMenu={buildCollapsableMenu}
               open={open}
               setOpen={setOpen}
            />
         </Drawer>
      </>
   )
}

export default withRouter(LeftMenu)
